
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Paper,
  TextField,
  Tooltip,
  Typography,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Divider,
  SelectChangeEvent,
  Select,
  MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { SetStateAction, useEffect, useState } from "react";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import Template from "../../../Shared-ui/Types/Template";
import { GitHub } from "../../../Shared-ui/Types/common";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
//import FormView from "./formView";



interface MyComponentProps {
  knowledgeBase: OldAgent | Template | any;
  setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | Template | any>>;
  getknowledgeBase: () => void;
  updateknowledgeBase: () => void;
}


const SourceGithub: React.FC<MyComponentProps> = (props) => {

  const githubInitial = {
    id: 0,
    repoName: "",
    branch: "",
    accessToken: "",
    repoOwner: ""
  }
  const gitHubErrInitial = {
    repoName: { value: false, error: "" },
    branch: { value: false, error: "" },
    accessToken: { value: false, error: "" },
    repoOwner: { value: false, error: "" },
  }
  const paginationModel = { page: 0, pageSize: 10 };
  const [gitHubs, setGitHubs] = useState<GitHub[]>([])
  const [gitHub, setGitHub] = useState<GitHub>(githubInitial)
  const [gitHubErr, setGitHubErr] = useState(gitHubErrInitial)
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false) // Track expanded panel
   const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false, });




  useEffect(() => {
    setGitHubs(props.knowledgeBase?.github || [])

  }, [props.knowledgeBase])
  const handleCancel = () => {
    setExpanded(false); // Reset expanded state
  };


  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target
    setGitHub(preVal => ({ ...preVal, [name]: value }))
  }


  const handleEdit = (githubId: number) => {
    const github = gitHubs?.filter((git: GitHub) => git.id === githubId)[0]
    setGitHub(github)
    setExpanded(true)
    setIsEditing(true)
  }

  const handleDelete = (githubId: number) => {
    setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
    props.setknowledgeBase((preVal: OldAgent) => {
      const existingGT = preVal.github || []
      const updatedGT = existingGT?.filter((git: GitHub) => git.id !== githubId)
      preVal.github = updatedGT
      return preVal
    })
    props.updateknowledgeBase()
  }

  const deleteConfirm = (row: number) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: handleDelete,
      functionParam: row,
    });
  };

  const handleSave = (githubId?: number) => {
    if (!validateGitHub()) return;

    if (githubId === null || githubId === undefined) {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingGitHub = preVal.github || []
        gitHub.id = existingGitHub[existingGitHub?.length - 1] && existingGitHub[existingGitHub?.length - 1].id >= 0 ? existingGitHub[existingGitHub?.length - 1].id + 1 : 0
        const updatedGT = [gitHub, ...existingGitHub]
        preVal.github = updatedGT
        return preVal
      })
    }
    else {
      props.setknowledgeBase((preVal: OldAgent) => {
        const existingGitHub = preVal.github || []
        existingGitHub[githubId].repoName = gitHub.repoName
        existingGitHub[githubId].branch = gitHub.branch
        existingGitHub[githubId].accessToken = gitHub.accessToken
        existingGitHub[githubId].repoOwner = gitHub.repoOwner
        preVal.github = existingGitHub
        return preVal
      })
    }
    setGitHub(githubInitial)
    setExpanded(false)
    props.updateknowledgeBase()
  };
  const validateGitHub = () => {
    let ErrCount = 0
    if (!gitHub.repoName?.trim()) {
      setGitHubErr((preVal) => ({ ...preVal, repoName: { error: "Please enter the name", value: true } }))
      ErrCount += 1
    } else {
      setGitHubErr((preVal) => ({ ...preVal, repoName: { error: "", value: false } }))
    }

    if (!gitHub.branch?.trim()) {
      setGitHubErr((preVal) => ({ ...preVal, branch: { error: "Please enter the branch", value: true } }))
      ErrCount += 1
    } else {
      setGitHubErr((preVal) => ({ ...preVal, branch: { error: "", value: false } }))
    }

    if (!gitHub.accessToken?.trim()) {
      setGitHubErr((preVal) => ({ ...preVal, accessToken: { error: "Please enter the accessToken", value: true } }))
      ErrCount += 1
    } else {
      setGitHubErr((preVal) => ({ ...preVal, accessToken: { error: "", value: false } }))
    }
    if (!gitHub.repoOwner?.trim()) {
      setGitHubErr((preVal) => ({ ...preVal, repoOwner: { error: "Please enter the accessToken", value: true } }))
      ErrCount += 1
    } else {
      setGitHubErr((preVal) => ({ ...preVal, repoOwner: { error: "", value: false } }))
    }


    return ErrCount === 0 ? true : false
  }


  const columns: GridColDef[] = [
    // { field: "id", headerName: "ID", width: 70 },
    { field: "repoName", headerName: "Name", width: 200 },
    { field: "accessToken", headerName: "Access Token", width: 200 },
    { field: "branch", headerName: "Branch", width: 200 },
    { field: "repoOwner", headerName: "Repo Owner", width: 200 },

    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        const handleEditClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          handleEdit(params.row.id)
        };

        const handleDeleteClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          deleteConfirm(params.row.id)
        };

        return (
          <Box>
            <IconButton aria-label="edit" onClick={handleEditClick}>
              <EditOutlinedIcon />
            </IconButton>
            <IconButton aria-label="delete" onClick={handleDeleteClick}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "block",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          ml: -2,
          mr: -2,
        }}
      >
        {/* Left Content */}
        <Box
          sx={{
            width: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            flex: "0 0 auto",
            boxSizing: "border-box",
            minWidth: {
              lg: "calc(100% - 300px)",
              md: "calc(100% - 300px)",
              sm: "100%",
            },
            pl: 2,
            pr: 2,
            maxWidth: "100%",
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Github
            </Typography>
            <Box>
              <Tooltip title="Add GitHub" placement="top">
                <IconButton
                  color="secondary"
                  aria-label="add icon"
                  sx={{ color: variables.primaryColor }}
                  onClick={() => setExpanded(true)}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          {/* Add Connection Box */}
          {expanded && (
            <Box
              sx={{
                "&::before": {
                  content: '""',
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 7,
                },
              }}
            >
              <Box
                sx={{
                  width: "500px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 3,
                  pt: "10px",
                  position: "fixed",
                  right: "0",
                  top: "0",
                  height: "100vh",
                  background: variables.whiteColor,
                  padding: "20px 30px",
                  zIndex: 8,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Typography variant="h6" gutterBottom>
                        New Github
                      </Typography>
                      <IconButton aria-label="close" onClick={handleCancel}>
                        <CloseIcon />
                      </IconButton>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 3,
                        mt: 2,
                        pt: "5px",
                        height: "calc(100vh - 160px)",
                        overflow: "auto",
                      }}
                    >
                      <FormControl fullWidth variant="outlined" required error={gitHubErr.repoName.value}>
                        <InputLabel
                          htmlFor="name"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Name
                        </InputLabel>
                        <TextField
                          //size="small"
                          id="name"
                          name="repoName"
                          onChange={handleChange}
                          error={gitHubErr.repoName.value}
                          helperText={gitHubErr.repoName.error}
                          value={gitHub.repoName}
                          placeholder="Enter the name"
                          sx={{ background: "white" }}
                        />
                      </FormControl>


                      <FormControl fullWidth variant="outlined" required error={gitHubErr.accessToken.value}>
                        <InputLabel
                          htmlFor="siteName"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Access Token
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="accessToken"
                          name="accessToken"
                          onChange={handleChange}
                          error={gitHubErr.accessToken.value}
                          helperText={gitHubErr.accessToken.error}
                          value={gitHub.accessToken}
                          placeholder="Enter Access Token"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required error={gitHubErr.branch.value}>
                        <InputLabel
                          htmlFor="folderPath"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Branch
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="branch"
                          name="branch"
                          onChange={handleChange}
                          error={gitHubErr.branch.value}
                          helperText={gitHubErr.branch.error}
                          value={gitHub.branch}
                          placeholder="Enter Branch"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                      <FormControl fullWidth variant="outlined" required error={gitHubErr.repoOwner.value}>
                        <InputLabel
                          htmlFor="clientId"
                          shrink
                          sx={{ background: "#fff", px: 0.5 }}
                        >
                          Repo Owner
                        </InputLabel>
                        <TextField
                          // size="small"
                          id="repoOwner"
                          name="repoOwner"
                          onChange={handleChange}
                          error={gitHubErr.repoOwner.value}
                          helperText={gitHubErr.repoOwner.error}
                          value={gitHub.repoOwner}
                          placeholder="Enter Repo Owner"
                          sx={{ background: "white" }}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      position: "absolute",
                      bottom: 0,
                    }}
                  >
                    <Button
                      fullWidth
                      variant="outlined"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={handleCancel} // Call handleCancel on click
                    >
                      Cancel
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      disableElevation
                      size="large"
                      sx={{
                        textTransform: "capitalize",
                      }}
                      onClick={() => handleSave(isEditing ? gitHub.id : undefined)}
                    >
                      Save
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}


          <Paper sx={{ height: 400, width: "100%", mt: "20px" }} elevation={0}>
            <DataGrid
              rows={gitHubs}
              columns={columns}
              pageSizeOptions={[10]}
              paginationMode="client"
              pagination={true}
              sx={{
                border: 1,
                borderColor: variables.borderColor,
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "& .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
              }}
            />
          </Paper>
        </Box>

        {/* Right Summary Card */}
        <Box
          sx={{
            width: { lg: "300px", md: "300px", sm: "100%" },
            minWidth: { lg: "300px", md: "300px", sm: "100%" },
            boxSizing: "border-box",
            flex: "0 0 auto",
            pl: 2,
            pr: 2,
            mt: { lg: "0", md: "0", sm: "30px" },
          }}
        >
          <SummaryCard />
        </Box>
      </Box>
      <ConfirmPopup details={confirmPopupData} />
    </Box>
  );
};

export default SourceGithub;

